<script setup>
import SpinnerIcon from "@js/components/icons/SpinnerIcon.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>

<template>
  <div class="flex flex-col items-center md:flex-row">
    <SpinnerIcon
      class="mb-1 mr-0 size-8 animate-spin fill-indigo-600 text-gray-200 md:mb-0 md:mr-2"
    />

    <span class="font-medium">
      {{ t("text.loading") }}
    </span>
  </div>
</template>
